import {SaleOfferStatus, TradeRecordKind} from '../../../models/generated-models';

/** Base path of the trade module — notification deep links resolve to `/ui/trade/{id}`. */
export const TRADE_BASE = '/trade';

/** Default unit; the backend `/units` list always contains this value. */
export const DEFAULT_TRADE_UNIT = 'กิโลกรัม';

/**
 * A ผู้ส่งออก business ends the chain: its PURCHASE carries the export
 * attributes instead of crediting stock.
 */
export const EXPORTER_BUSINESS_TYPE_TITLE = 'ผู้ส่งออก';

/** `SHIPMENT` is legacy — no new record is ever written with that kind. */
export const TRADE_KIND_LABELS: Record<TradeRecordKind, string> = {
  HARVEST: 'ผลผลิต',
  PURCHASE: 'รับซื้อ',
  SHIPMENT: 'ขนส่ง',
  TRANSFORM: 'แปรรูป'
};

/** Bootstrap badge classes per kind, matching the app's card/badge language. */
export const TRADE_KIND_BADGE_CLASSES: Record<TradeRecordKind, string> = {
  HARVEST: 'text-bg-success',
  PURCHASE: 'text-bg-primary',
  SHIPMENT: 'text-bg-warning',
  TRANSFORM: 'text-bg-info'
};

export function tradeKindLabel(kind: TradeRecordKind | null | undefined): string {
  return kind ? TRADE_KIND_LABELS[kind] ?? String(kind) : '-';
}

/** An exporter's purchase ends the chain, so it is worded รับส่งออก rather than รับซื้อ. */
export function tradeRecordLabel(record: {kind?: TradeRecordKind | null; export?: boolean | null} | null | undefined): string {
  if (!record) {
    return '-';
  }
  return record.export && record.kind === 'PURCHASE' ? 'รับส่งออก' : tradeKindLabel(record.kind);
}

export function tradeKindBadgeClass(kind: TradeRecordKind | null | undefined): string {
  return kind ? TRADE_KIND_BADGE_CLASSES[kind] ?? 'text-bg-secondary' : 'text-bg-secondary';
}

export const SALE_OFFER_STATUS_LABELS: Record<SaleOfferStatus, string> = {
  OPEN: 'รอผู้ซื้อรับ',
  ACCEPTED: 'รับแล้ว',
  CANCELLED: 'ยกเลิก'
};

export const SALE_OFFER_STATUS_BADGE_CLASSES: Record<SaleOfferStatus, string> = {
  OPEN: 'text-bg-warning',
  ACCEPTED: 'text-bg-success',
  CANCELLED: 'text-bg-secondary'
};

export function saleOfferStatusLabel(status: SaleOfferStatus | null | undefined): string {
  return status ? SALE_OFFER_STATUS_LABELS[status] ?? String(status) : '-';
}

export function saleOfferStatusBadgeClass(status: SaleOfferStatus | null | undefined): string {
  return status ? SALE_OFFER_STATUS_BADGE_CLASSES[status] ?? 'text-bg-secondary' : 'text-bg-secondary';
}

/** A sale offer QR carries `"O-" + uuid`; a lot/stock QR carries `T-`/`S-`. */
export function isSaleOfferCode(code: string | null | undefined): boolean {
  return /^o-/i.test((code ?? '').trim());
}

/** `certification` mirrors the backend column (1-based). */
export const TRADE_CERTIFICATION = {
  NONE: 1,
  OTHER: 2
} as const;
